import PropTypes from 'prop-types'
import React from 'react'
import Base from '../../containers/BaseContainer'
import { I18n } from 'react-redux-i18n'

import classNames from 'classnames'
import globalStyles from '../../styles/styles.module.scss'
import styles from './Header.module.scss'
import Tour from '../Tour/Tour'

import Constants from '../../services/constants/Constants'
import { hasAuthorization } from '../../ContentUtils'
import ReleaseNote from '../ReleaseNote/ReleaseNote'

export const viewers = ['ios', 'android']
export const profileMenu = ['account', 'team', 'myApps', 'admin', 'logout']

class Header extends Base {

  constructor(props) {
    super(props)
    this._bind('_handleAppViewerChange', '_handleProfileChange', '_handleTeamChange')
  }

  _viewers(type, index, props) {
    let classList = type === 'ios' ? classNames(styles.ios) : classNames(styles.android)
    let storeURL = type === 'ios'
      ? Constants.UrlsConstants.urlViewerIos : Constants.UrlsConstants.urlViewerAndroid
    storeURL += '&locale=' + props.currentLocale
    return <li key={index} className={styles.item}>
      <a href={storeURL}>
        <div className={classList}></div>
        <span>{I18n.t('Header.' + type)}</span>
      </a>
    </li>
  }

  _renderTeam(team, index, props) {
    return <li key={index} className={styles.item} data-linkid={team.owner}
      onClick={(event) => { this._closeMenuTeam(); this.props.onChangeTeamClick(event) }}>
      {team.owner}
    </li>
  }

  _closeMenuTeam() {
    document.querySelector('#teams').checked = false
  }

  _closeMenu() {
    document.querySelector('#pr').checked = false
  }

  _profileMenuItems(type, index, props) {
    // console.log(this.props.app)
    if (type === 'admin' && props.user.authorizations &&
      !hasAuthorization(props.user, Constants.AuthConstants.ADMIN) &&
      !hasAuthorization(props.user, Constants.AuthConstants.MANAGE_FREMIUM)) {
      return null
    }

    if (type === 'myApps' && (!this.props.app.id || (props.user.authorizations &&
      props.user.authorizations.indexOf(Constants.AuthConstants.PLAYER_ONLY) !== -1))) {
      return null
    }

    if (type === 'team' && (props.user.isFreemium || (props.user.authorizations &&
      props.user.authorizations.indexOf(Constants.AuthConstants.PLAYER_ONLY) !== -1))) {
      return null
    }

    let funcOnClick = props.onMyAccountClick
    let classList = classNames(styles.account)

    if (type === 'account') {
      classList = classNames(styles.account)
      funcOnClick = props.onMyAccountClick
    } else if (type === 'team') {
      classList = classNames(styles.team)
      funcOnClick = props.onMyTeamClick
    } else if (type === 'settings') {
      classList = classNames(styles.settings)
      funcOnClick = props.onMySettingsClick
    } else if (type === 'logout') {
      classList = classNames(styles.logout)
      funcOnClick = props.onLogoutClick
    } else if (type === 'myApps') {
      classList = classNames(styles.apps)
      funcOnClick = props.onLogoClick
    } else if (type === 'admin') {
      classList = classNames(styles.admin)
      funcOnClick = props.onAdmin
    }

    return <li key={index} className={styles.item} data-linkid={index}
      onClick={() => { this._closeMenu(); funcOnClick() }}>
      <div className={classList}></div>
      <span>{I18n.t('Header.' + type)}</span>
    </li>
  }

  _handleTeamChange(event) {
    if (event.currentTarget.checked &&
      document.querySelector('#pr').checked) {
      document.querySelector('#pr').checked = false
    }
    if (event.currentTarget.checked &&
      document.querySelector('#av').checked) {
      document.querySelector('#av').checked = false
    }
  }

  _handleAppViewerChange(event) {
    if (event.currentTarget.checked &&
      document.querySelector('#pr').checked) {
      document.querySelector('#pr').checked = false
    }
    if (event.currentTarget.checked &&
      document.querySelector('#teams').checked) {
      document.querySelector('#teams').checked = false
    }
  }

  _handleProfileChange(event) {
    if (event.currentTarget.checked && document.querySelector('#av') &&
      document.querySelector('#av').checked) {
      document.querySelector('#av').checked = false
    }
    if (event.currentTarget.checked && document.querySelector('#teams') &&
      document.querySelector('#teams').checked) {
      document.querySelector('#teams').checked = false
    }
  }

  render() {
    let globalHeaderClassList = classNames(globalStyles.header,
      this.props.isHeaderDisplayed ? null : globalStyles.smallHeader)
    let headerClassList = classNames(styles.header)
    let logoClassList = classNames(styles.logo,
      this.props.isMenuOpened ? null : styles.smallWidthLogo)

    let playerOnly = this.props.user.authorizations &&
      this.props.user.authorizations.indexOf(Constants.AuthConstants.PLAYER_ONLY) !== -1

    let teamsVisibility = (!playerOnly && this.props.isTeamDisplayed === true &&
      this.props.user.teams &&
      this.props.user.teams.length > 0)

    return (
      <div className={globalHeaderClassList}>
        <header className={headerClassList}>
          <div className={logoClassList} onClick={this.props.onLogoClick}></div>
          <div className={styles.search}>
            {/* <input type='text' placeholder={I18n.t('Header.search')} onChange={this.props.onSearch} />*/}
          </div>
          {teamsVisibility ? <div className={styles.userTeam}>
            <input id='teams' type='checkbox' className={styles.checkOpenMenu} onChange={this._handleTeamChange} />
            <div className={styles.teams}></div>
            <span>{I18n.t('Header.team')}</span>
            <ul className={styles.list}>
              <li key={-1} data-linkid={this.props.user.email}
                className={styles.item}
                onClick={(event) => { this._closeMenuTeam(); this.props.onChangeTeamClick(event) }}>
                {I18n.t('Header.myApps')}
              </li>
              {this.props.user.teams.map((team, index) => {
                return this._renderTeam(team, index, this.props)
              })}
            </ul>
          </div> : null}
          {this.props.isRefreshDisplayed === false ? <div id='viewer' className={styles.appViewer}>
            <input id='av' type='checkbox' className={styles.checkOpenMenu} onChange={this._handleAppViewerChange} />
            <div className={styles.eye}></div>
            <span>{I18n.t('Header.appViewer')}</span>
            <ul className={styles.list}>
              {viewers.map((viewer, index) => {
                return this._viewers(viewer, index, this.props)
              })}
            </ul>
          </div> : null}

          {this.props.isRefreshDisplayed === true ? <div id='refresh' className={styles.refresh}
            onClick={this.props.onRefreshClick} /> : null}
          {this.props.currentTour !== '/account/myteam'
            ? <div id='help' className={styles.help} onClick={this.props.onShowFAQ}></div> : null}
          {this.props.currentTour === '/account/myteam'
            ? <div id='help' className={styles.help} onClick={this.props.onHelpClick}>
              <Tour tour={this.props.currentTour} showTour={this.props.isHelpDisplayed}
                onMissingHelp={this.props.onMissingHelp}
                onEndTour={this.props.onEndTour} />
            </div> : null}
          <div id='releaseNote' className={styles.releaseNote} onClick={this.props.handleShowReleaseNote}></div>
          {this.props.releaseNoteShow
            ? <ReleaseNote
              forceShow={this.props.releaseNoteShow}
              list={this.props.releaseNoteList}
              selectedNote={this.props.releaseNoteSelected}
              onClose={this.props.handleCloseShow}
            />
            : null}
          <div className={styles.userProfile}
            data-firstname={this.props.user && this.props.user.firstname
              ? this.props.user.firstname.substr(0, 1) : null}
            data-lastname={this.props.user && this.props.user.lastname
              ? this.props.user.lastname.substr(0, 1) : null}>
            <input id='pr' type='checkbox' className={styles.checkOpenMenu} onChange={this._handleProfileChange} />
            <span />
            <ul className={styles.list}>
              {profileMenu.map((item, index) => {
                return this._profileMenuItems(item, index, this.props)
              })}
            </ul>
          </div>
        </header>
      </div>
    )
  }
}

Header.propTypes = {
  isMenuOpened: PropTypes.bool.isRequired,
  isHeaderDisplayed: PropTypes.bool.isRequired,
  isHelpDisplayed: PropTypes.bool.isRequired,
  isTeamDisplayed: PropTypes.bool.isRequired,
  isRefreshDisplayed: PropTypes.bool.isRequired,
  currentTour: PropTypes.string.isRequired,
  onShowFAQ: PropTypes.func.isRequired,
  onEndTour: PropTypes.func.isRequired,
  onHelpClick: PropTypes.func.isRequired,
  onRefreshClick: PropTypes.func.isRequired,
  onMissingHelp: PropTypes.func.isRequired,
  onLogoClick: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onMyAccountClick: PropTypes.func.isRequired,
  onMyTeamClick: PropTypes.func.isRequired,
  onMySettingsClick: PropTypes.func.isRequired,
  onLogoutClick: PropTypes.func.isRequired,
  onChangeTeamClick: PropTypes.func.isRequired,
  onAdmin: PropTypes.func.isRequired,
  user: PropTypes.object,
}

export default Header
